/* ==========================================================================
   ZELICAT THEME - header-mega.js
   Desktop mega menu of the header (from 1101px wide; below that the nav is hidden
   and the mobile drawer is used, which this file never touches).
   - opens on hover (with a small delay) and when the link gets keyboard focus
   - the left column switches the cards on the right (hover, focus, arrows, click)
   - Escape closes and gives the focus back to the link; leaving the menu closes it
   - touch screens: the first tap opens the menu, the second tap follows the link
   Markup comes from snippets/header-mega.liquid. Vanilla JS, no dependencies.
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;
  const { $, $$ } = ZC;
  const desktop = window.matchMedia('(min-width: 1101px)');
  const OPEN_DELAY = 70;
  const CLOSE_DELAY = 200;
  const TAB_DELAY = 90;

  const menus = [];

  /* card pictures carry their address in data attributes: load them only when the menu is about to be used */
  function loadImages(scope) {
    $$('img[data-mega-src]', scope).forEach((img) => {
      img.srcset = img.getAttribute('data-mega-srcset') || '';
      img.src = img.getAttribute('data-mega-src');
      img.removeAttribute('data-mega-src');
      img.removeAttribute('data-mega-srcset');
    });
  }

  function closeAll(except) {
    menus.forEach((m) => { if (m !== except && m.isOpen()) m.close(); });
  }

  function init(li) {
    const trigger = $('[data-mega-trigger]', li);
    const panel = $('[data-mega-panel]', li);
    if (!trigger || !panel) return;
    for (let i = menus.length - 1; i >= 0; i -= 1) { if (!document.body.contains(menus[i].li)) menus.splice(i, 1); }
    const header = li.closest('[data-header]');
    const tabs = () => $$('[data-mega-tab]', panel);
    const panes = () => $$('[data-mega-pane]', panel);
    let openTimer = 0;
    let closeTimer = 0;
    let tabTimer = 0;
    let lastPointer = 'mouse';
    let quiet = false;   /* true while the focus is moved by the script itself (no re-open) */

    const isOpen = () => !panel.hidden;
    const defaultTab = () => tabs().find((t) => t.dataset.megaDefault === '1') || tabs()[0];
    /* remember which tab the server rendered as selected: it is the default one */
    const initial = tabs().find((t) => t.getAttribute('aria-selected') === 'true');
    if (initial) initial.dataset.megaDefault = '1';

    function place() {
      panel.style.setProperty('--mega-top', Math.round(panel.getBoundingClientRect().bottom) + 'px');
    }

    function activate(tab, moveFocus) {
      if (!tab) return;
      tabs().forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      const id = tab.getAttribute('aria-controls');
      panes().forEach((p) => { p.hidden = p.id !== id; });
      if (moveFocus) { quiet = true; tab.focus(); quiet = false; }
    }

    function open() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      if (!desktop.matches || isOpen()) return;
      closeAll(api);
      loadImages(panel);
      activate(defaultTab(), false);
      panel.hidden = false;
      li.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      place();
    }

    function close(returnFocus) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      clearTimeout(tabTimer);
      if (!isOpen()) return;
      panel.hidden = true;
      li.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) { quiet = true; trigger.focus(); quiet = false; }
    }

    const api = { isOpen, close, open, li, panel, activate, tabs, panes, defaultTab };
    menus.push(api);

    /* ---- pointer */
    li.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'touch') return;
      if (desktop.matches) loadImages(panel);
      clearTimeout(closeTimer);
      if (isOpen()) return;
      openTimer = setTimeout(open, OPEN_DELAY);
    });
    li.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'touch') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => close(false), CLOSE_DELAY);
    });
    trigger.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType || 'mouse'; });
    trigger.addEventListener('click', (e) => {
      if (lastPointer === 'touch' && desktop.matches && !isOpen()) { e.preventDefault(); open(); }
    });
    document.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch' && isOpen() && !li.contains(e.target)) close(false);
    });

    /* ---- keyboard focus */
    trigger.addEventListener('focus', () => {
      if (quiet || !desktop.matches) return;
      let visible = true;
      try { visible = trigger.matches(':focus-visible'); } catch (err) { visible = true; }
      if (visible) open();
    });
    li.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!isOpen() || li.contains(document.activeElement)) return;
        if (li.matches(':hover')) return;
        close(false);
      }, 0);
    });
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' && desktop.matches) {
        e.preventDefault();
        open();
        activate(defaultTab(), true);
      }
    });
    panel.addEventListener('keydown', (e) => {
      const list = tabs();
      const current = document.activeElement;
      const i = list.indexOf(current);
      if (i > -1) {
        let next = null;
        if (e.key === 'ArrowDown') next = list[(i + 1) % list.length];
        else if (e.key === 'ArrowUp') next = list[(i - 1 + list.length) % list.length];
        else if (e.key === 'Home') next = list[0];
        else if (e.key === 'End') next = list[list.length - 1];
        else if (e.key === 'ArrowRight') {
          const first = $('[data-mega-pane]:not([hidden]) a[href]', panel);
          if (first) { e.preventDefault(); first.focus(); }
          return;
        }
        if (next) { e.preventDefault(); activate(next, true); }
      } else if (e.key === 'ArrowLeft' && current && current.closest('[data-mega-pane]')) {
        const sel = list.find((t) => t.getAttribute('aria-selected') === 'true');
        if (sel) { e.preventDefault(); sel.focus(); }
      }
    });

    /* ---- left column: hover / focus / click switch the cards */
    tabs().forEach((tab) => {
      tab.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        clearTimeout(tabTimer);
        tabTimer = setTimeout(() => activate(tab, false), TAB_DELAY);
      });
      tab.addEventListener('pointerleave', () => clearTimeout(tabTimer));
      tab.addEventListener('focus', () => { if (!quiet) activate(tab, false); });
      tab.addEventListener('click', (e) => {
        if (tab.tagName === 'BUTTON') { e.preventDefault(); activate(tab, false); }
        else if (tab.getAttribute('aria-selected') !== 'true') { e.preventDefault(); activate(tab, false); }
      });
    });

    /* desktop only: fetch the pictures of the default category once the page is idle, so the first opening has no pop-in */
    const warm = () => {
      if (!desktop.matches) return;
      const first = $('[data-mega-pane]:not([hidden])', panel);
      if (first) loadImages(first);
    };
    const idle = window.requestIdleCallback ? (fn) => window.requestIdleCallback(fn, { timeout: 4000 }) : (fn) => setTimeout(fn, 2000);
    if (document.readyState === 'complete') idle(warm);
    else window.addEventListener('load', () => idle(warm), { once: true });

    /* the header hides itself while scrolling down: close the menu with it, otherwise keep the shade in place */
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!isOpen() || ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        if (header && header.classList.contains('is-hidden')) close(false);
        else if (isOpen()) place();
      });
    }, { passive: true });
    const onChange = () => { if (!desktop.matches) close(false); else if (isOpen()) place(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange);
    window.addEventListener('resize', () => { if (isOpen()) place(); });
  }

  /* ---- shared listeners (added once) */
  if (!window.__zcMegaBound) {
    window.__zcMegaBound = true;
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const m = menus.find((x) => x.isOpen());
      if (!m) return;
      const inside = m.li.contains(document.activeElement);
      m.close(inside);
    });

    /* theme editor: show the menu (and the right category) when its blocks are selected */
    const forBlock = (target) => {
      const li = target.closest ? target.closest('[data-mega]') : null;
      return li ? menus.find((x) => x.li === li) : null;
    };
    document.addEventListener('shopify:block:select', (e) => {
      const m = forBlock(e.target);
      if (!m) return;
      m.open();
      const pane = e.target.closest('[data-mega-pane]');
      const tab = e.target.matches('[data-mega-tab]') ? e.target : (pane ? $('#' + pane.getAttribute('aria-labelledby'), m.panel) : null);
      if (tab) m.activate(tab, false);
    });
    document.addEventListener('shopify:block:deselect', (e) => { const m = forBlock(e.target); if (m) m.close(false); });
    document.addEventListener('shopify:section:select', (e) => {
      const li = $('[data-mega]', e.target);
      const m = li && menus.find((x) => x.li === li);
      if (m) m.open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const li = $('[data-mega]', e.target);
      const m = li && menus.find((x) => x.li === li);
      if (m) m.close(false);
    });
    document.addEventListener('shopify:section:unload', () => {
      for (let i = menus.length - 1; i >= 0; i -= 1) { if (!document.body.contains(menus[i].li)) menus.splice(i, 1); }
    });
  }

  ZC.mount((root) => {
    $$('[data-mega]', root).forEach((li) => { if (ZC.once(li, 'mega')) init(li); });
  });
})();
